export const messagesEn = {
  BrowserError: {
    Title: 'Unsupported browser',
    Content: 'Please, change your browser to the latest Chrome, Firefox or Opera to continue.',
  },
  ServerError: {
    Title: 'Server error',
    Content: 'Some error has occurred on the server. Forgive us, please. And try again.',
  },
};



// WEBPACK FOOTER //
// ./src/messages/messages-en.ts